module.exports = __webpack_public_path__ + "static/pozyczki_mazowieckie-437bbf492f1130ed3ffdbe41df25cf82.png";